module.exports = __webpack_public_path__ + "img/Cancel-icon.fcdde227.svg";